import * as React from 'react';

interface SearchIconProps {
  ariaName?: string;
}

export const Search: React.VFC<SearchIconProps> = ({ ariaName }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 7C11.5 9.48528 9.48528 11.5 7 11.5C4.51472 11.5 2.5 9.48528 2.5 7C2.5 4.51472 4.51472 2.5 7 2.5C9.48528 2.5 11.5 4.51472 11.5 7ZM10.6795 11.7397C9.66345 12.5296 8.38666 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 8.38641 12.5298 9.66299 11.7401 10.679L15.0304 13.9692L13.9697 15.0299L10.6795 11.7397Z"
        fill="#767676"
      />
    </svg>
  );
};
